import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

import LikeliHoodAverage from './LikelihoodAverageModel';

const InsightProductMatchesRecord = Record({
  fees: null,
  governmentBacked: null,
  lender: null,
  likelihood: null,
  product: '',
  revenue: 0,
});

export default class InsightProductMatches extends InsightProductMatchesRecord {
  static deserialize(jsonObject = {}) {
    const mapProperties = {
      likelihood: LikeliHoodAverage.deserialize,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new InsightProductMatches(hydrated);
  }
}
